import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type SectionTitleProps = {
  children: React.ReactNode;
};

const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => (
  <Typography
    variant="h4"
    sx={{
      mb: 16,
      ml: 16,
    }}
  >
    {children}
  </Typography>
);

type FilterSectionProps = {
  title?: string;
  children?: React.ReactNode;
  ['data-testid']?: string;
} & React.ComponentProps<'div'>;

export const FilterSection: React.FC<FilterSectionProps> = ({ title, children, ...props }) => {
  return (
    <Box {...props}>
      {title ? <SectionTitle>{title}</SectionTitle> : null}
      {children}
    </Box>
  );
};
